export default {
    namespaced:true,

    //准备actions--用于响应组件中的actions
    actions: {
      
    },

    //准备mutations--用于操作数据
    mutations: {
        UPDATECOURSE(state, data) {
            state.course.id = data.id
            state.course.courseName = data.courseName
            state.course.photo = data.photo
            state.course.participants = data.participants
            state.course.price = data.price
            state.course.courseAbout = data.courseAbout
            state.course.words = data.words
            state.course.createTime = data.createTime
        }
    },

    //创建getters 用于对state的数据进行加工
    getters: {
        
    },

    //准备state--用于存储数据
    state: {
        /* 课程表 */
        course:{
            id:'',
            courseName:'',
            photo:'',
            participants:'',
            price:'',
            courseAbout:'',
            words:'',
            createTime:'',
        },
    }
}